import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface DepthOfFieldEffectProperties extends EffectProperties {
  focusDistance: number;
  focalLength: number;
  bokehScale: number;
}

// Create a reusable DepthOfField component that can be used in both preview and world
const DepthOfFieldComponent = forwardRef<any, { properties: DepthOfFieldEffectProperties; isPreview?: boolean }>((props, ref) => {
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { focusDistance, focalLength, bokehScale } = properties;

  return (
    <PostProcessing.DepthOfField
      ref={ref}
      focusDistance={focusDistance}
      focalLength={focalLength}
      bokehScale={bokehScale}
    />
  );
});

export const DepthOfFieldEffectItem: Effect<DepthOfFieldEffectProperties> = {
  id: '',
  name: 'Depth Of Field',
  type: 'effect',
  subtype: 'DepthOfField',
  icon: 'Effect',
  properties: {
    focusDistance: 0.0,
    focalLength: 0.1,
    bokehScale: 2.0,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.focusDistance',
      type: 'number',
      label: 'Focus Distance',
      default: 0.0,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'effect',
    },
    {
      key: 'properties.focalLength',
      type: 'number',
      label: 'Focal Length',
      default: 0.1,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'effect',
    },
    {
      key: 'properties.bokehScale',
      type: 'number',
      label: 'Bokeh Scale',
      default: 2.0,
      min: 0,
      max: 10,
      step: 0.1,
      panel: 'effect',
    }
  ],
  render: (properties: DepthOfFieldEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <DepthOfFieldComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
};